import { configureStore } from '@reduxjs/toolkit'
import { adminReducer } from './reducer/authReducer/adminReducer.js';
import { firstStep } from './reducer/stepReducer/stepReducer.js';

const store = configureStore({
  reducer: { 
    adminReducer: adminReducer.reducer,
    firstStep: firstStep.reducer
  },
});

export default store;
// import { configureStore } from '@reduxjs/toolkit'

// export const store = configureStore({
//   reducer: {},
// })
